module.exports = __webpack_public_path__ + "6c72fe43c7a6d55263f80c1dd37d139d.MP3";